import React, { useEffect, useRef } from 'react';
import "../../css/Home/HomeBot.css"
import getScript from "../../language";

const brands = [
    { src: "/images/logos/knorr-bremse.svg", alt: "Knorr-Bremse", scale: 1.2 },
    { src: "/images/logos/DT-large.jpeg", alt: "DT Spare Parts", scale: 1.2 },
    { src: "/images/logos/monroe.png", alt: "Monroe", scale: 1.4 },
    { src: "/images/logos/moog.png", alt: "Moog", scale: 2.5 },
    { src: "/images/logos/ferodo.png", alt: "Ferodo", scale: 1.5 },
    { src: "/images/logos/champion.png", alt: "Champion", scale: 1.05 },
    { src: "/images/logos/sampa.png", alt: "Sampa", scale: 1.4 },
    { src: "/images/logos/cummins.png", alt: "Cummins", scale: 1.5 },
    { src: "/images/logos/victor-reinz.png", alt: "Victor Reinz", scale: 1.8 },
    { src: "/images/logos/sachs.jpg", alt: "Sachs", scale: 2.5 },
    { src: "/images/logos/CEI.png", alt: "CEI", scale: 0.85 },
    { src: "/images/logos/zf.png", alt: "ZF", scale: 1.3 },
    { src: "/images/logos/oegermany.png", alt: "OE Germany", scale: 2.95 },
    { src: "/images/logos/elring.png", alt: "Elring", scale: 1.4 },
    { src: "/images/logos/osram.png", alt: "Osram", scale: 0.9 },
    { src: "/images/logos/sem.png", alt: "SEM", scale: 2.15 },
    { src: "/images/logos/dinex.png", alt: "Dinex", scale: 1.4 },
    { src: "/images/logos/xxl.png", alt: "XXL", scale: 1.7 },
    { src: "/images/logos/fte.png", alt: "FTE", scale: 0.9 },
    { src: "/images/logos/delphi.png", alt: "Delphi", scale: 0.75 },
    { src: "/images/logos/wabco.png", alt: "WABCO", scale: 1.5 },
    { src: "/images/logos/valeo.png", alt: "Valeo", scale: 1.05 },
    { src: "/images/logos/FAG.png", alt: "FAG", scale: 0.65 },
    { src: "/images/logos/icer.png", alt: "Icer", scale: 2.85 },
    { src: "/images/logos/neotec.jpg", alt: "Neotec", scale: 3.25 },
    { src: "/images/logos/mycaliper.png", alt: "My Caliper", scale: 1.2 },
    { src: "/images/logos/dayco.png", alt: "Dayco", scale: 3.25 },
    { src: "/images/logos/lemforder.png", alt: "Lemforder", scale: 3.15 },
    { src: "/images/logos/lumag.svg", alt: "Lumag", scale: 1.15 },
    { src: "/images/logos/fersa.svg", alt: "Fersa", scale: 1.15 },
    { src: "/images/logos/sicit.png", alt: "Sicit", scale: 1.15 },
    { src: "/images/logos/driv.png", alt: "Driv", scale: 1.15 },
    { src: "/images/logos/jurid.png", alt: "Jurid", scale: 1.15 },
    { src: "/images/logos/fp-diesel.png", alt: "FP-Diesel", scale: 1.15 },
    { src: "/images/logos/nural.png", alt: "Nural", scale: 1.65 },
    { src: "/images/logos/goetze.png", alt: "Goetze", scale: 1.45 },
    { src: "/images/logos/glyco.png", alt: "Glyco", scale: 3.25 },
    { src: "/images/logos/borgwarner.png", alt: "Borgwarner", scale: 1.45 },
    { src: "/images/logos/beru.png", alt: "Beru", scale: 1.85 },
    { src: "/images/logos/vibracoustic.png", alt: "Vibracoustic", scale: 1.55 },
];

const HomeBot = (props) => {
    const gridRef = useRef(null);
    const script = getScript("home_bot");

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const card = entry.target;
                    card.classList.add('visible');
                    // Clear the stagger delay once the entrance finishes so it
                    // doesn't slow down the hover transition.
                    card.addEventListener('transitionend', () => {
                        card.style.transitionDelay = '0s';
                    }, { once: true });
                    observer.unobserve(card);
                }
            });
        }, { threshold: 0.08 });

        const cards = gridRef.current?.querySelectorAll('.brand-card');
        cards?.forEach((card, i) => {
            card.style.transitionDelay = `${i * 0.04}s`;
            observer.observe(card);
        });

        props.ready('bot');

        return () => observer.disconnect();
    }, []);

    return (
        <div id='Home_HomeBot'>
            <div className="brand-section">
                <div className="section-header">
                    <span className="section-badge section-badge--oem">{script.OEM_PARTNERS}</span>
                </div>
                <div className="brand-grid" ref={gridRef}>
                    {brands.map((brand, i) => (
                        <div className="brand-card" style={{"--logo-scale": brand.scale}} key={i}>
                            <img src={brand.src} alt={brand.alt} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default HomeBot;
